/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".width[_ngcontent-%COMP%]{width:100%}span[_ngcontent-%COMP%]{line-height:1.7;font-size:inherit}.alternate[_ngcontent-%COMP%]{background-color:#eff4fa}"];
export { styles as styles };
